import gql from 'graphql-tag';
import FieldsTransaction from 'graphql/fields/FieldsTransaction';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'credit_bundle_guid': 'String!',
	'amount': 'Int',
}

export default gql(`
	mutation transaction( ${ HelperGraphql.createFields( fields ) } ) {
	    transaction( ${ HelperGraphql.createVariables( fields ) } ) {
			${ FieldsTransaction }
	    }
	}
`);

